import React from 'react'
import GenericTitleP from '../../titles/GenericTitleP'
import LowBox from './lowBox/LowBox'

const LowBoxes = () => {


  return (<div className='d-flex flex-column mt-4 '>
    <GenericTitleP>Running Low</GenericTitleP>
    <p className='w-100'>Items in this section are below <span className='text-danger fw-bold'>15%</span> of the initial addition quantity</p>
    <div className='d-flex flex-row flex-wrap align-items-center justify-content-center'>
      {[0,1,2,3,4,5,6,7,8,9,10].map((x,i) => <LowBox key={x} quantity={Math.ceil(Math.random()*12)} id={x}/>)}
    </div>
  </div>)
}

export default LowBoxes